import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from '@/routes/utils';

const MobileApp = lazyWithRetry(() => import('@/pages/mobile/MobileApp'));

export const mobileRoutes = (
  <Route path="/app" element={<MobileApp />} />
);
